import React, { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { element, func, shape, string } from 'prop-types';

import { Modal } from '../../../../../../components';
import WebhookForm from '../WebhookForm';
import WebhooksForm from '../WebhooksForm';
import { modalConfig } from '../../utils/webhookModalHelpers';
import EarlyExitModal from '../WebhookForm/components/EarlyExitModal';

const WebhooksModal = ({
  actions: { toggleWebhookModal },
  mode,
  upgradeCta,
  upgradeMessage,
  webhookVersion,
}) => {
  // note: this flag refers to the UI version 2, not a specific webhook version
  const { webhooksV2Enabled: webhooksUIv2 } = useFlags();

  const modalName = mode;
  // only allow v4 webhooks if v2 UI is enabled
  let webhooksV4Enabled = webhooksUIv2;
  // if the selected webhook to edit is on an older version, revert to v1 UI
  if (webhookVersion && webhookVersion !== '4.0') {
    webhooksV4Enabled = false;
  }

  // Exit modal applies to Webhook V2 UI form only
  const [showExitModal, setShowExitModal] = useState(false);
  const [disableExitModal, setDisableExitModal] = useState(true);
  const toggleWebhookExitModal = () => {
    // skip the exit modal if the user hasn't made any changes yet
    if (disableExitModal) {
      toggleWebhookModal({ nextModal: null, curModal: modalName, trackCloseEvent: true });
    } else {
      setShowExitModal(!showExitModal);
    }
  };

  const content = webhooksV4Enabled ? (
    <WebhookForm
      mode={mode}
      toggleWebhookModal={toggleWebhookModal}
      toggleWebhookExitModal={toggleWebhookExitModal}
      setDisableExitModal={setDisableExitModal}
    />
  ) : (
    <WebhooksForm
      mode={mode}
      upgradeCta={upgradeCta}
      upgradeMessage={upgradeMessage}
    />
  );

  const toggleWebhookFormModal = () => {
    toggleWebhookModal({ nextModal: null, curModal: modalName, trackCloseEvent: true });
  };

  return (
    <React.Fragment>
      {webhooksV4Enabled ? (
        <Modal
          content={content}
          toggleModal={toggleWebhookExitModal}
          divider={false}
          fullScreen
        />
      ) : (
        <Modal
          title={modalConfig[modalName].title}
          content={content}
          toggleModal={toggleWebhookFormModal}
          divider={false}
        />
      )}
      {showExitModal && (
        <EarlyExitModal
          showExitModal={showExitModal}
          setShowExitModal={setShowExitModal}
          toggleWebhookModal={toggleWebhookFormModal}
        />
      )}
    </React.Fragment>
  );
};

export default WebhooksModal;

WebhooksModal.propTypes = {
  actions: shape({
    toggleWebhookModal: func.isRequired,
  }).isRequired,
  mode: string.isRequired,
  upgradeCta: element,
  upgradeMessage: element,
  webhookVersion: string,
};

WebhooksModal.defaultProps = {
  upgradeCta: null,
  upgradeMessage: null,
  webhookVersion: null,
};
